import { AppState } from '../../../core/Store';
import { State } from './reducer';

type Selector<T = any> = (redState: State, appState: AppState) => T;
function prepareSelector<T>(selector: Selector<T>) {
	return (state: AppState) => {
		return selector(state.ui.app, state);
	};
}

export const getIsBodyScrolled = prepareSelector((redState, appState) => {
	return redState.isBodyScrolled;
});

export const getViewportWidth = prepareSelector((redState, appState) => {
	return redState.viewportWidth;
});

export const getAppLoaded = prepareSelector((redState, appState) => {
	return redState.loaded;
});

export const getPaymentStatus = prepareSelector((redState, appState) => {
	return redState.paymentStatus;
});

export const getLastPaymentIntervalId = prepareSelector(
	(redState, appState) => {
		return redState.lastPaymentIntervalId;
	}
);
